import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card flex-fill justify-self-stretch" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = { class: "input-group input-group-sm" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "card-body",
  style: {"min-height":"10rem"}
}
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-12 col-lg-6 col-xl-5 mb-2" }
const _hoisted_9 = { class: "col-12 col-lg-6 col-xl-7 flex-column" }
const _hoisted_10 = { class: "mt-2 row" }
const _hoisted_11 = { class: "col-12 col-sm-5 text-sm-start text-center" }
const _hoisted_12 = { class: "col-12 col-sm-7 text-center text-sm-end" }
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = {
  key: 2,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_19 = { class: "col-12 text-center text-sm-end mb-2" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_23 = { class: "row text-center" }
const _hoisted_24 = {
  key: 0,
  class: "col-10 col-xl-6 offset-1 offset-xl-3 mt-3"
}
const _hoisted_25 = {
  key: 1,
  class: "col-10 col-xl-6 offset-1 offset-xl-3 mt-3"
}
const _hoisted_26 = {
  class: "modal show",
  id: "change-email-modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-body" }
const _hoisted_30 = { class: "mb-3 row" }
const _hoisted_31 = { class: "col-sm-10" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "form-floating mb-3" }
const _hoisted_34 = {
  key: 0,
  class: "text-warning small"
}
const _hoisted_35 = {
  key: 1,
  class: "text-danger small"
}
const _hoisted_36 = { class: "modal-footer justify-content-center" }
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_card = _resolveComponent("profile-card")!
  const _component_carrer_summary_table = _resolveComponent("carrer-summary-table")!
  const _component_package_icon = _resolveComponent("package-icon")!
  const _component_user_not_found = _resolveComponent("user-not-found")!
  const _component_searching = _resolveComponent("searching")!
  const _component_profile_picture_gallery_modal = _resolveComponent("profile-picture-gallery-modal")!
  const _component_error_modal = _resolveComponent("error-modal")!
  const _component_information_modal = _resolveComponent("information-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", null, [
        _createElementVNode("h5", { class: "mb-0 mt-1" }, [
          _createElementVNode("i", { class: "fas fa-search fa-fw me-1" }),
          _createTextVNode(" Buscar socio ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Usuario / Correo Electrónico",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.username,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
            disabled: _ctx.username == '' || _ctx.searching
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fas fa-search" }, null, -1)
          ]))], 8, _hoisted_5)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.userData.username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_profile_card, { user: _ctx.userData }, null, 8, ["user"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_carrer_summary_table, {
                class: "border rounded bg-light",
                "user-data": _ctx.userData
              }, null, 8, ["user-data"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.actions.changeEmail)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-outline-secondary btn-sm text-nowrap mb-2",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showChangeEmailModal && _ctx.showChangeEmailModal(...args)))
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "far fa-envelope fw me-1" }, null, -1),
                        _createTextVNode(" Cambiar Correo ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productosEnVenta, (producto, indice) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: producto.id,
                      class: _normalizeClass(["btn btn-outline-secondary btn-sm mb-2", { 'ms-2': indice > 0 }]),
                      disabled: _ctx.isOffline || _ctx.isQuoting,
                      onClick: ($event: any) => (_ctx.subscriptionQuote(producto.id))
                    }, [
                      (producto.iconoClase)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass([producto.iconoClase, "me-1"])
                          }, null, 2))
                        : (_openBlock(), _createBlock(_component_package_icon, {
                            key: 1,
                            product: producto.id,
                            colored: "",
                            "extra-class": "me-1"
                          }, null, 8, ["product"])),
                      _createTextVNode(_toDisplayString(producto.etiqueta) + " ", 1),
                      (_ctx.isQuoting)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_13))
                  }), 128)),
                  (_ctx.actions.upgradeToBasic && !_ctx.productoRetirado('gtr-fly'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-outline-secondary btn-sm ms-2 mb-2",
                        disabled: _ctx.isOffline || _ctx.isQuoting,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.subscriptionQuote('gtr-fly', 'upgrade', 'go-to-fly-upgrade')
                ))
                      }, [
                        _createVNode(_component_package_icon, {
                          product: "gtr-fly",
                          colored: "",
                          "extra-class": "me-1"
                        }),
                        _cache[12] || (_cache[12] = _createTextVNode("GTR Fly (Upgrade) ", -1)),
                        (_ctx.isQuoting)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (_ctx.actions.upgradeToVip && !_ctx.productoRetirado('gtr-win'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-outline-secondary btn-sm ms-2 mb-2",
                        disabled: _ctx.isOffline || _ctx.isQuoting,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (
                  _ctx.subscriptionQuote('gtr-win', 'upgrade', 'go-to-win-upgrade')
                ))
                      }, [
                        _createVNode(_component_package_icon, {
                          product: "gtr-win",
                          colored: "",
                          "extra-class": "me-1"
                        }),
                        _cache[13] || (_cache[13] = _createTextVNode("GTR Win (Upgrade) ", -1)),
                        (_ctx.isQuoting)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.actions.noVolume)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-outline-info btn-sm",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.registerWithNoVolume())),
                          disabled: _ctx.isOffline || _ctx.activating
                        }, [
                          _cache[14] || (_cache[14] = _createTextVNode(" Activar SIN volumen ", -1)),
                          (_ctx.activating)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_21))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        (_ctx.notFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_user_not_found)
            ]))
          : _createCommentVNode("", true),
        (_ctx.searching)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_searching)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header bg-secondary text-light py-2" }, [
            _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "fas fa-envelope fa-fw me-2" }),
              _createTextVNode(" Cambiar correo electrónico ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-sm btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "staticUsername",
                class: "col-sm-2 col-form-label"
              }, "Usuario: ", -1)),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("input", {
                  type: "text",
                  readonly: "",
                  class: "form-control-plaintext fw-bold",
                  id: "staticUsername",
                  value: _ctx.username
                }, null, 8, _hoisted_32)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_33, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control mb-1",
                  id: "newEmail",
                  placeholder: "Nuevo E-mail",
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateEmailInput && _ctx.validateEmailInput(...args))),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newEmail) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.newEmail]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("label", { for: "floatingInput" }, "Nuevo Correo Electrónico (E-mail)", -1)),
                (_ctx.emailValidation.hasWarning)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw mx-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.emailValidation.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw mx-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[19] || (_cache[19] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary mx-3",
              "data-bs-dismiss": "modal"
            }, " Cancelar ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary mx-3",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeEmail())),
              disabled: !_ctx.canChangeEmail
            }, " Aceptar ", 8, _hoisted_37)
          ])
        ])
      ])
    ]),
    _createVNode(_component_profile_picture_gallery_modal),
    _createVNode(_component_error_modal, {
      title: _ctx.errorTitle,
      message: _ctx.errorMessage
    }, null, 8, ["title", "message"]),
    _createVNode(_component_information_modal, {
      title: _ctx.informationTitle,
      message: _ctx.informationMessage
    }, null, 8, ["title", "message"])
  ]))
}